import Api from "@/helpers/api";
import { loading, closeLoding, notify, confirm } from "@/helpers/$vs";
import moment from "moment";

export default {
  data() {
    return {
      listTokens: [],
      listCompanies: [],
      dataToUpdate: {
        token: "",
        user: "",
        companyID: "",
        comapny: "",
        email: "",
        expireAccount: moment().add(8, "days").toDate()
      },
      option: 0,
      today: moment().unix(),
      popupActive: false,
      format: "dd MMMM yyyy",
      disabledDates: {
        to: moment().add(7, "days").toDate(),
        from: moment().add(14, "days").toDate()
      },

      itemsPerPage: 5
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format("DD MMM YYYY");
    }
  },
  methods: {
    /**
     * Obtiene la lista de tokens y la almacena en la variable 'listTokens'
     */
    async getTokens() {
      try {
        loading();
        const result = await Api.get("/auth/sessions/companies");
        this.listTokens = result.data;
      } catch (error) {
        const message = error.error ? error.error : `(${error.message})`;
        let text = "";
        if (message === "Sessions list are empty") text = this.$t(`ACCESTOKENS.emptyTokens`);
        notify(this.$t(`ACCESTOKENS.listTokens`), text, "warning");

        // console.log('Error listTokens: getTokens ', error);
      } finally {
        closeLoding();
      }
    },
    /**
     * Levanta un dialogo de confirmación para eliminar un token
     * @param {string} key - id ó key del token
     */
    confirmDelete(key) {
      confirm({
        title: this.$t(`ACCESTOKENS.titleAlert`),
        text: this.$t(`ACCESTOKENS.messageAlert`),
        accept: () => this.deleteToken(key),
        acceptText: this.$t(`ACCESTOKENS.accept`),
        cancelText: this.$t(`ACCESTOKENS.cancel`)
      });
    },
    /**
     * Elimina un token
     * @param {string} key - id ó key del token
     */
    async deleteToken(key) {
      try {
        loading();
        await Api.delete("/auth/sessions/" + key);
        this.getTokens();
      } catch (error) {
        console.log("Error listTokens: getTokens ", error);
      } finally {
        closeLoding();
      }
    },
    /**
     * Almacena la información de un token en la variable 'dataToUpdate' para su posterior actualización
     * @param {object} tr - Es un objeto que contiene las propiedades que se van a actualizar del token
     * @property {string}  tr.accessToken
     * @returns {void} - Termina la ejecución de la función cuando la fecha de expiración a configurar es menor a la actual.
     */
    editToken(tr) {
      const company = this.listCompanies.find(comapny => comapny.key === tr.companyID);
      const today = moment().unix();
      const expireAccount = moment(company.expireAccount).unix();

      if (expireAccount < today) {
        const msg = `${this.$t(`ACCESTOKENS.dateEpiredCompany1`)}${tr.companyName}${this.$t(`ACCESTOKENS.dateEpiredCompany2`)}`;
        return confirm({ title: "Alerta", text: msg, type: "alert" });
      }

      this.disabledDates.from = moment(company.expireAccount).add(1, "days").toDate();
      this.dataToUpdate = {
        token: tr.accessToken,
        user: tr.name,
        companyID: tr.companyID,
        company: tr.companyName,
        email: tr.email,
        expireAccount: moment().add(8, "days").toDate()
      };
      this.popupActive = true;
    },
    /**
     * Actualiza la fecha de expiración de un token
     */
    async updateToken() {
      try {
        loading();
        const data = {
          companyID: this.dataToUpdate.companyID,
          dateToExpire: moment(this.dataToUpdate.expireAccount).format("YYYY-MM-DD"),
          timeToExpire: "23:59:59"
        };
        await Api.put("/auth/sessions/" + this.dataToUpdate.token, data);
        notify(this.$t(`ACCESTOKENS.update`), this.$t(`ACCESTOKENS.tokenIsUpdated`));
        this.popupActive = false;
        this.getTokens();
        this.clear();
      } catch (error) {
        notify(this.$t(`ACCESTOKENS.errorToUpdate`), this.$t(`ACCESTOKENS.CanNotUpdate`), "danger");
        console.log("Error listTokens: updateToken ", error);
      } finally {
        closeLoding();
      }
    },
    /**
     * Resetea las variables para la actualización de un token.
     */
    clear() {
      this.disabledDates.from = moment().add(14, "days").toDate();
      this.dataToUpdate = {
        token: "",
        user: "",
        companyID: "",
        comapny: "",
        email: "",
        expireAccount: moment().add(8, "days").toDate()
      };
    },
    /**
     * Obtiene la lista de compañías.
     */
    async getCompanies() {
      try {
        const result = await Api.get("/companies");
        this.listCompanies = result.data;
      } catch (error) {
        console.log("Error listTokens: getCompanies ", error);
      } finally {
        closeLoding();
      }
    }
  },
  computed: {
    /**
     * @returns {Array} - Retorna una lista de tokens acivos
     */
    _filterTokens() {
      return this.listTokens.filter(token => token.status === "Active");
    },
    /**
     *
     * @returns {Array} - Retorna una lista de tokens ordenada por fecha de expiración
     */
    _orderListTokens() {
      return this._filterTokens.sort(
        (a, b) => moment(a.expireToken).format("YYYYDDMM") - moment(b.expireToken).format("YYYYDDMM")
      );
    },
    /**
     *
     * @returns {Array} - Retorna una lista de tokens según la opción (1.activos, 2. vencidos)
     */
    _getFilter() {
      return this._orderListTokens.filter(({ expireToken }) => {
        if (this.option === 1) return moment(expireToken).unix() >= this.today;
        if (this.option === 2) return moment(expireToken).unix() < this.today;
        return true;
      });
    },
    /**
     *
     * @returns {Array} - Devuelve un objeto con iertas propiedades relevantes de losmtokens
     */
    _mapListTokens() {
      return this._getFilter.map(token => {
        return {
          key: token.key,
          accessToken: token.accessToken,
          name: `${token.name} ${token.lastname}`,
          email: token.email,
          companyID: token.companyID,
          companyName: token.companyName,
          expireToken: token.expireToken
        };
      });
    }
  }
};
